// TODO(onda 2): src/lib/utils/address.ts (isValidCpf/isValidCnpj) passa a reexportar daqui (mover, não copiar).

export const apenasDigitos = (v: string): string => v.replace(/\D/g, '');

/** Telefone BR só com dígitos: 10 (fixo) ou 11 (celular, com 9 depois do DDD). */
export function telefoneBrValido(valor: string): boolean {
  const d = apenasDigitos(valor);
  return d.length === 10 || (d.length === 11 && d[2] === '9');
}

/** Corpo de `isValidCpf` (src/lib/utils/address.ts:116-140). */
export function isValidCpf(cpf: string): boolean {
  const d = apenasDigitos(cpf);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  const dv = (n: number) => {
    let sum = 0;
    for (let i = 0; i < n; i++) sum += Number(d[i]) * (n + 1 - i);
    const r = (sum * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dv(9) === Number(d[9]) && dv(10) === Number(d[10]);
}

const PESOS_CNPJ = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

/** Corpo de `isValidCnpj` (src/lib/utils/address.ts:144-170). */
export function isValidCnpj(cnpj: string): boolean {
  const d = apenasDigitos(cnpj);
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const dv = (n: number) => {
    const pesos = PESOS_CNPJ.slice(13 - n);
    const r = pesos.reduce((sum, p, i) => sum + Number(d[i]) * p, 0) % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return dv(12) === Number(d[12]) && dv(13) === Number(d[13]);
}

/** CPF (11) ou CNPJ (14) com dígito verificador válido. */
export const isValidCpfOuCnpj = (doc: string): boolean => {
  const d = apenasDigitos(doc);
  return d.length === 11 ? isValidCpf(d) : d.length === 14 && isValidCnpj(d);
};

/** CPF com máscara: 000.000.000-00 (aceita parcial, para máscara de campo). */
export function formatCpf(value: string): string {
  const d = apenasDigitos(value).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/** CNPJ com máscara: 00.000.000/0000-00 (aceita parcial, para máscara de campo). */
export function formatCnpj(value: string): string {
  const d = apenasDigitos(value).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

/** Telefone com máscara: (00) 00000-0000 (aceita parcial, para máscara de campo). */
export function formatPhone(value: string): string {
  const d = apenasDigitos(value).slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Celular BR: 11 dígitos com 9 depois do DDD (o que a Clicksign aceita por WhatsApp e SMS). */
export const celularBrValido = (valor: string): boolean => {
  const d = apenasDigitos(valor);
  return d.length === 11 && d[2] === '9';
};
